import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

const Navbar: React.FC = () => {
  return (
    <>
      <style jsx>{`
        nav {
          background-color: darkgreen;
          display: flex;
          align-items: center;
          padding: 0px 24px;
          color: #fff;
          transition: all 0.3s ease 0s;
          height: 80px;
          position: relative;
          z-index: 1000000;
        }

        .inner-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          transition: all 0.3s ease 0s;
          position: relative;
          width: 40%;
          padding: 0px 24px;
        }

        .link {
          display: flex;
          font-weight: bold;
          font-size: 24px;
          height: 100%;
          justify-content: center;
          align-items: center;
          color: white;
          padding: 0 15px;
          white-space: nowrap; /* Keep phrases on the same line */
        }

        .logo {
          flex-shrink: 0; /* Prevent the logo from shrinking */
        }

        @media (max-width: 768px) {
          .link {
            font-size: 18px; /* Smaller font size for smaller screens */
            padding: 0 5px;
          }

          .inner-container {
            width: 100%;
            padding: 0 10px;
            justify-content: flex-start;
          }

          nav {
            padding: 0 10px;
          }
        }

        @media (max-width: 400px) {
          .link {
            font-size: 14px; /* Even smaller font size for very small screens */
          }

        @media (max-width: 318px) {
          .link {
            font-size: 11px; /* Even smaller font size for very small screens */
          }
        }
      `}</style>

      <nav>
        <div className="inner-container">
          <div className="logo">
            <Image src="/assets/appstore.png" alt="Naitram Logo" width={60} height={60} />
          </div>
          <Link href="/" passHref>
            <a className="link">Privacy Policy</a>
          </Link>
          <Link href="/delete" passHref>
            <a className="link">Delete Data</a>
          </Link>
          <Link href="/support" passHref>
            <a className="link">Support</a>
          </Link>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
